import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CustomAuthService } from './custom-auth.service';
import { GlobalStateQuery } from '../state/global.appstate.query';
import { switchMap, take } from 'rxjs/operators';
import { from, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
    private globalState: GlobalStateQuery,
    private auth: CustomAuthService,
    private router: Router
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Attempt to restore the session's authentication between app reloads.
    // This will prevent unnecessary redirects to the login page.

    //TOOD why are those vals here empty? to late?  how to wait but not bloc
    // After we have loaded the 
    // console.log("Current route", route)

    // const envVal = this.auth.envConfig$.getValue()
    // console.log("env val", envVal)

    if (this.auth.session.token == null) {
      return from(this.auth.loadTokenFromStorage()).pipe(switchMap(() => {
        if (!this.auth.session.isAuthenticated || this.auth.envConfig$.getValue() == null) {
          return of(this.router.parseUrl('/serverconfig'));
        }
        return of(this.auth.session.isAuthenticated);
      }
      ), take(1));
    }
    return of(this.auth.session.isAuthenticated);

  }
}
